<template>
	<inertia-head title="Bo Sanchez FREE Book - Multiple Income Streams" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h2 class="fw-bold text-white mb-2">
						Get Bro Bo's Book for FREE!
					</h2>
					<h1 class="fw-bold text-white mb-2">
						Multiple Income Streams<br>
						How I Created 7 Money Machines and How You Can Too!
					</h1>
					<h4 class="fw-normal text-white-75 fs-sm">
						Grab Bro. Bo's latest printed book! It's not available anywhere else, so make sure to get your copy now and enjoy!
					</h4>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-5 col-lg-5">
				<img src="/media/images/mis-book-mockup.jpg" alt="" class="img-fluid mb-2">
			</div>
			<div class="col-sm-12 col-md-7 col-lg-7">
				<h2 class="text-center">Fill out the details below!</h2>
				<h4 class="text-center">You'll receive a QR Code from us, which you'll need to show to our team at the Truly Rich Club Booth to redeem your free book!</h4>
				<h1 class="text-center"><i class="fa fa-arrow-down"></i></h1>
				<div class="block block-rounded shadow">
					<div class="block-content block-content-full">
						<div class="form-group mb-3">
							<label>First Name</label>
							<input type="text" v-model="form.fname" name="fname" class="form-control" />
							<span v-if="form.errors.fname" class="text-danger">{{form.errors.fname}}</span>
						</div>
						<div class="form-group mb-3">
							<label>Last Name</label>
							<input type="text" v-model="form.lname" name="lname" class="form-control" />
							<span v-if="form.errors.lname" class="text-danger">{{form.errors.lname}}</span>
						</div>
						<div class="form-group mb-3">
							<label>Email Address</label>
							<input type="text" v-model="form.email" name="email" class="form-control" />
							<span v-if="form.errors.email" class="text-danger">{{form.errors.email}}</span>
						</div>
						<div class="form-group mb-3">
							<label>Mobile</label>
							<vue-tel-input
								@input="onInput"
								@countryChanged="onCountryChange"
								v-model="form.mobile"
								:value="form.mobile"
								class="form-control"
								:class="{ 'is-invalid': form.errors.mobile }"
								:input-options="{
									placeholder: 'Enter mobile number',
								}"
								:defaultCountry="form.country_code"
								mode="international"
							/>
							<span v-if="form.errors.mobile" class="text-danger">{{form.errors.mobile}}</span>
						</div>
						<div class="form-group mt-4 text-center">
							<button @click="claimBook" type="button" class="btn btn-success btn-lg" :disabled="form.processing">
								<div
									v-if="form.processing"
									class="spinner-border spinner-border-sm text-white me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-envelope me-1"></i>
								Send My QRCode Now!
							</button>
						</div>
						
					</div>
				</div>

				<div class="block-content block-content-full">
					<p class="text-gray-dark">Disclaimer:
						We're excited for the free book you're receiving from us! By subscribing to our newsletter, 
					you'll stay updated on our latest offerings, special promotions, and valuable content. Your email 
				address is safe with us, and we will never share it with others. If you ever wish to unsubscribe, you 
			can do so easily at any time. Thank you for joining our community and being a part of our financial freedom journey!</p>
				</div>

			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; <span data-toggle="year-copy"></span>
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/FreeBookLayout';
	import { watch, ref, onMounted } from 'vue'
	import { useForm } from '@inertiajs/inertia-vue3'
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: GuestLayout,
		props:{
			flash 			: Object,
		},
		setup(props){

			const form = useForm({
				fname 		: '',
				lname 		: '',
				email 		: '',
				country_calling_code: '63',
				country_code: '',
				mobile		: ''
			})

			const onInput = (number, phoneObject) => {
				if (phoneObject?.formatted) {
					form.mobile 				= phoneObject.number;
					form.country_calling_code 	= phoneObject.countryCallingCode;
				}
				if(phoneObject.formatted=='')
				{
					form.mobile = '';
				}
			}

			const onCountryChange = (countryObject) => {
				form.country_code = countryObject.iso2
			}

			const claimBook = ()=>{
				form.post(route("freebook-store"),{
					only:['flash,errors']
				});
			}

			watch(
				() => props.flash,
				(flash) => {
					if (flash && flash.toast) {
						if(flash.toast.type=='success')
						{
							Inertia.get("multiply/thankyou");
						}
						
					}
				}
			)

			return {
				form,
				onInput,
				onCountryChange,
				claimBook
			}

		}
	}
</script>